import { render, staticRenderFns } from "./aLteDescriptionBlock.vue?vue&type=template&id=5e745c5e"
import script from "./aLteDescriptionBlock.vue?vue&type=script&lang=js"
export * from "./aLteDescriptionBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5e745c5e', component.options)
    } else {
      api.reload('5e745c5e', component.options)
    }
    module.hot.accept("./aLteDescriptionBlock.vue?vue&type=template&id=5e745c5e", function () {
      api.rerender('5e745c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/miscellaneous/aLteDescriptionBlock.vue"
export default component.exports